export default __webpack_public_path__ + "static/media/vintage100-6.0adfe157.jpg";